import { baseLayerLuminance, StandardLuminance } from '@microsoft/fast-components';
import { DesignToken } from '@microsoft/fast-foundation';
import { darkColors, lightColors } from './colors';
const { create } = DesignToken;
export const agThemeGenesisRapidTokens = {
    backgroundColor: create('rapid-ag-background-color').withDefault((elem) => baseLayerLuminance.getValueFor(elem) === StandardLuminance.LightMode
        ? lightColors.backgroundSwatch
        : darkColors.backgroundSwatch),
    borderColor: create('rapid-ag-border-color').withDefault((elem) => baseLayerLuminance.getValueFor(elem) === StandardLuminance.LightMode
        ? lightColors.borderSwatch
        : darkColors.borderSwatch),
    foregroundColor: create('rapid-ag-foreground-color').withDefault((elem) => baseLayerLuminance.getValueFor(elem) === StandardLuminance.LightMode
        ? lightColors.foregroundSwatch
        : darkColors.foregroundSwatch),
    headerForegroundColor: create('rapid-ag-header-foreground-color').withDefault((elem) => baseLayerLuminance.getValueFor(elem) === StandardLuminance.LightMode
        ? lightColors.headerForegroundSwatch
        : darkColors.headerForegroundSwatch),
    rowHoverColor: create('rapid-ag-row-hover-color').withDefault((elem) => baseLayerLuminance.getValueFor(elem) === StandardLuminance.LightMode
        ? lightColors.rowHoverSwatch
        : darkColors.rowHoverSwatch),
};
